import {
  aiadTransactionsApi,
  tcQrCodeApi,
  aiadOrderApi,
  tcWechatApi,
  tcAlipayApi,
  aiadStorageApi,
} from './apis';

let env;
let defHttp;

export function setEnv(v) {
  env = v;
}

export function getEnv() {
  return env;
}

export function setApi(v) {
  defHttp = v;
}

export function getApi() {
  return {
    aiadTransactionsApi: aiadTransactionsApi(defHttp),
    tcQrCodeApi: tcQrCodeApi(defHttp),
    aiadOrderApi: aiadOrderApi(defHttp),
    tcWechatApi: tcWechatApi(defHttp),
    tcAlipayApi: tcAlipayApi(defHttp),
    aiadStorageApi: aiadStorageApi(defHttp),
  };
}
